export const APP_BASE = 'APP_BASE' // APP详情
export const APPCLOUD_ID = 'APPCLOUD_ID' // appcloud_id

export const GET_APP_BASE = 'GET_APP_BASE' // 获取APP详情
export const SET_APP_BASE = 'SET_APP_BASE' // 设置APP详情
export const GET_APP_VERSIONS = 'GET_APP_VERSIONS'
export const SET_APP_VERSIONS = 'SET_APP_VERSIONS'

export const UPDATE_APP_BASE = 'UPDATE_APP_BASE' // 更新APP详情

export const CREATE_APP_VERSION = 'CREATE_APP_VERSION' // 创建APP版本
export const DELETE_APP_VERSION = 'DELETE_APP_VERSION' // 删除APP版本
export const PUBLISH_APP_VERSION = 'PUBLISH_APP_VERSION' // 发布APP版本
export const COPY_APP_VERSION = 'COPY_APP_VERSION' // 复制APP版本
export const CHECK_APP_VERSION_CAN_DEL = 'CHECK_APP_VERSION_CAN_DEL' // 检查app版本是否可以删除

export const ADD_APP_BUILD = 'ADD_APP_BUILD' // 添加APP版本发布状态
export const REMOVE_APP_BUILD = 'REMOVE_APP_BUILD' // 移除APP版本发布状态

export const GET_LAST_APP_VERSIONS = 'GET_LAST_APP_VERSIONS' // 获取最新各环境APP版本
export const SET_LAST_APP_VERSIONS = 'SET_LAST_APP_VERSIONS' // 设置最新各环境APP版本

export const GET_ALL_PUBLISHED_APP_VERSIONS = 'GET_ALL_PUBLISHED_APP_VERSIONS' // 获取各环境全部可复制APP版本
export const SET_ALL_PUBLISHED_APP_VERSIONS = 'SET_ALL_PUBLISHED_APP_VERSIONS' // 设置各环境全部可复制APP版本

export const GET_ALL_APP_VERSIONS = 'GET_ALL_APP_VERSIONS' // 获取各环境全部APP版本
export const SET_ALL_APP_VERSIONS = 'SET_ALL_APP_VERSIONS' // 设置各环境全部APP版本

export const GET_LAST_ENGINE_VERSIONS = 'GET_LAST_ENGINE_VERSIONS' // 获取各环境引擎版本
export const SET_LAST_ENGINE_VERSIONS = 'SET_LAST_ENGINE_VERSIONS' // 设置各环境引擎版本

export const GET_ALL_ENGINE_VERSIONS = 'GET_ALL_ENGINE_VERSIONS' // 获取引擎列表
export const SET_ALL_ENGINE_VERSIONS = 'SET_ALL_ENGINE_VERSIONS' // 设置引擎列表

export const ADD_APP_VERSION_COMPONENTS = 'ADD_APP_VERSION_COMPONENTS' // 添加APP版本引用组件

export const GET_APP_VERSION_USED_COMPONENT = 'GET_APP_VERSION_USED_COMPONENT' // 获取APP版本引用组件
export const GET_APP_VERSION_ALL_COMPONENT = 'GET_APP_VERSION_ALL_COMPONENT' // 获取APP版本引用组件
export const GET_ALL_COMPONENT_PACKAGES = 'GET_ALL_COMPONENT_PACKAGES' // 获取APP版本引用组件
export const GET_SYSTEM_COMPONENT = 'GET_SYSTEM_COMPONENT' // 获取APP版本引用组件

export const GET_COMPONENT_VERSIONS = 'GET_COMPONENT_VERSIONS' // 获取组件版本列表
export const GET_BUILD_LOGS = 'GET_BUILD_LOGS' // 获取构建记录，版本 or 引用组件

export const BUILD_APP_VERSION = 'BUILD_APP_VERSION' //构建APP版本
export const BUILD_APP_VERSION_COMPONENT = 'BUILD_APP_VERSION_COMPONENT' //构建APP版本组件
export const GET_APP_VERSION_BUILDS = 'GET_APP_VERSION_BUILDS' // 获取APP版本构建列表
export const GET_APP_VERSION_BUILD_STATUS = 'GET_APP_VERSION_BUILD_STATUS' // 获取APP版本构建状态

export const HAS_APP_SUPPORT = 'HAS_APP_SUPPORT' // 是否支持混合APP
export const HAS_MOBILE_SITE_SUPPORT = 'HAS_MOBILE_SITE_SUPPORT' // 是否支持H5

export const GET_APP_SHELL_VERSION = 'GET_APP_SHELL_VERSION' // 获取APP壳版本信息
export const GET_ALL_APP_SHELL_VERSION = 'GET_ALL_APP_SHELL_VERSION' // 获取APP已有壳版本信息
export const SAVE_APP_SHELL_VERSION = 'SAVE_APP_SHELL_VERSION' // 保存APP壳版本信息

export const GET_APP_API = 'GET_APP_API' // 获取APP API信息
export const SAVE_APP_API = 'SAVE_APP_API' // 保存APP API信息

export const GET_WEBAPP_VARS = 'GET_WEBAPP_VARS' // 获取 webapp vars
export const SET_WEBAPP_VARS = 'SET_WEBAPP_VARS' // 设置 webapp vars

export const GET_TENANT_LIST = 'GET_TENANT_LIST' // 获取租户列表
export const SET_TENANT_LIST = 'SET_TENANT_LIST' // 设置租户列表
export const GET_TENANT_UPDATE_INFO = 'GET_TENANT_UPDATE_INFO' // 获取某个租户最后更新的信息
export const SET_TENANT_UPDATE_INFO = 'SET_TENANT_UPDATE_INFO' // 设置某个租户最后更新的信息
export const SET_TENANT_VERSIONS = 'SET_TENANT_VERSIONS' // 设置租户使用版本列表
export const SET_TENANT_UPDATE_VERSIONS = 'SET_TENANT_UPDATE_VERSIONS' // 设置租户可用的版本列表
export const UPDATE_TENANT = 'UPDATE_TENANT' // 升级租户版本
export const DELETE_TENANT = 'DELETE_TENANT' // 删除租户版本
export const GET_TENANT_LOG = 'GET_TENANT_LOG' // 获取租户日志

export const GET_ALI_LOGS = 'GET_ALI_LOGS' // 获取阿里云日志列表
export const GET_ALI_LOG = 'GET_ALI_LOG' // 获取阿里云日志

// 模版
export const CREATE_TEMPLATE = 'CREATE_TEMPLATE'
export const GET_TEMPLATE_LIST = 'GET_TEMPLATE_LIST'
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE'
export const CHECK_TEMPLATE_NAME = 'CHECK_TEMPLATE_NAME'
export const EDIT_TEMPLATE = 'EDIT_TEMPLATE'
export const SUBMIT_TEMPLATE = 'SUBMIT_TEMPLATE'
export const COPY_TEMPLATE = 'COPY_TEMPLATE'

// 业务对象
export const GET_SERVICE_LIST = 'GET_SERVICE_LIST'
export const ADD_SERVICE = 'ADD_SERVICE'
export const EDIT_SERVICE = 'EDIT_SERVICE'
export const DELETE_SERVICE = 'DELETE_SERVICE'

// 新业务对象分组
export const GET_NEW_OBJECT_GROUP = 'GET_NEW_OBJECT_GROUP'
export const ADD_NEW_OBJECT_GROUP = 'ADD_NEW_OBJECT_GROUP'
export const EDIT_NEW_OBJECT_GROUP = 'EDIT_NEW_OBJECT_GROUP'
export const DEL_NEW_OBJECT_GROUP = 'DEL_NEW_OBJECT_GROUP'

// 新业务对象
export const GET_NEW_OBJECT = 'GET_NEW_OBJECT'
export const ADD_NEW_OBJECT = 'ADD_NEW_OBJECT'
export const EDIT_NEW_OBJECT = 'EDIT_NEW_OBJECT'
export const DEL_NEW_OBJECT = 'DEL_NEW_OBJECT'
export const GET_NEW_OBJECT_DTL = 'GET_NEW_OBJECT_DTL'

// 新业务对象字段
export const GET_NEW_OBJECT_FIELD = 'GET_NEW_OBJECT_FIELD'
export const ADD_NEW_OBJECT_FIELD = 'ADD_NEW_OBJECT_FIELD'
export const EDIT_NEW_OBJECT_FIELD = 'EDIT_NEW_OBJECT_FIELD'
export const DEL_NEW_OBJECT_FIELD = 'DEL_NEW_OBJECT_FIELD'

// 新服务分组
export const GET_NEW_SERVICE_GROUP = 'GET_NEW_SERVICE_GROUP'
export const ADD_NEW_SERVICE_GROUP = 'ADD_NEW_SERVICE_GROUP'
export const EDIT_NEW_SERVICE_GROUP = 'EDIT_NEW_SERVICE_GROUP'
export const DEL_NEW_SERVICE_GROUP = 'DEL_NEW_SERVICE_GROUP'

// 新服务
export const GET_NEW_SERVICE = 'GET_NEW_SERVICE'
export const ADD_NEW_SERVICE = 'ADD_NEW_SERVICE'
export const EDIT_NEW_SERVICE = 'EDIT_NEW_SERVICE'
export const DEL_NEW_SERVICE = 'DEL_NEW_SERVICE'

export const BUILD_PC = 'BUILD_PC'
export const GET_PC_VERSIONS = 'GET_PC_VERSIONS'
export const GET_PC_BUILD_HISTORY = 'GET_PC_BUILD_HISTORY'

// app 更新
export const GET_APP_UPGRADE_CONFIG = 'GET_APP_UPGRADE_CONFIG'
export const PUT_APP_UPGRADE_CONFIG = 'PUT_APP_UPGRADE_CONFIG'

// 获取app版本引用组件-我的组件列表
export const GET_APP_VERSION_MY_COMPONENT_LIST = 'GET_APP_VERSION_MY_COMPONENT_LIST'
// 获取app版本引用组件-系统组件列表
export const GET_APP_VERSION_SYSTEM_COMPONENT_LIST = 'GET_APP_VERSION_SYSTEM_COMPONENT_LIST'
export const GET_PARENT_APP_VERSIONS = 'GET_PARENT_APP_VERSIONS'
export const SET_PARENT_APP_VERSIONS = 'SET_PARENT_APP_VERSIONS'

export const GET_OBJECT_DETAIL = 'GET_OBJECT_DETAIL'
